<template>
  <div class="system-notice-wrapper" ref="wrapperRef">
    <div  class="system-notice" v-if="list && list.length > 0" @scroll="onScroll">
      <div ref="contentRef">
        <div class="system-notice-item" v-for="(item, index) in list" :key="index">
            <div class="system-notice-icon">
              <img src="../../assets/img/headline/system-notice.svg" alt="" />
            </div>
            <div class="system-notice-content">
              <div class="system-notice-text is-title"></div>
              <div class="system-notice-text"></div>
            </div>
        </div>
      </div>
    </div>
    <div v-else class="list-empty">
      <img src="../../assets/img/common/newEmpty.png" alt="">
      <p>暂无通知</p>
    </div>
  </div>
</template>

<script>
export  default {
  name: 'SystemNotice',
  props: {
    list: {
      type: Array,
      default: ()=>{
        return []
      }
    }
  },
  methods: {
    onScroll(e){
      const height = this.$refs.wrapperRef.clientHeight
      const offsetHeight = this.$refs.contentRef.offsetHeight
      const scrollTop = e.target.scrollTop
      if (scrollTop / (offsetHeight - height + 0.2) >= 0.95) {
        this.$emit('load')
      }
    },
    clearAll(){
      this.$emit('clear')
    }
  }
}
</script>

<style lang="less" scoped>
.system-notice {
  height: 100%;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(#dcdcdc, 0.3);
    border-radius: 4px;
  }

  &-wrapper {
    height: 100%;
    overflow: hidden;
  }
  &-item {
    display: flex;
    align-items: center;
    height: 64px;
    padding-left: 30px;
    &:hover {
      background: #F5F6F6;
    }
  }
  &-icon {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 40px;
    background: rgba(65, 180, 140, 0.06);
    border-radius: 6px 6px 6px 6px;

    img {
      display: block;
      width: 20px;
    }
  }
  &-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: hidden;
    padding-left: 12px;
    padding-right: 100px;
  }
  &-text {
    font-weight: 400;
    font-size: 12px;
    color: #829191;
    text-align: left;
    font-style: normal;
    line-height: 20px;
    &.is-title {
      font-size: 14px;
      color: #050F0F;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.list-empty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  p {
    font-size: 14px;
    line-height: 20px;
    color: #B9C3C3;
    font-weight: 500;
    margin-top: 14px;
  }
}
</style>
